import 'slick-carousel'

export default () => {
  $('.slideshow').on('init reInit afterChange', function(event, slick, currentSlide){
    startProgressbar();
    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000, // 4 секунды
        pauseOnHover: false,
        arrows: true,
        appendArrows: $('.slideshow-bottom'),
        prevArrow: `<button type="button" class="slick-prev first-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                    <path d="M6.5 11L1.5 6L6.5 1" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </button>`,
        nextArrow: `<button type="button" class="slick-next first-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                      <path d="M1.5 11L6.5 6L1.5 1" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>`,

    });

    let progressBar, progressInterval;
    let time = 4000; // должен совпадать с autoplaySpeed

    function startProgressbar() {
        resetProgressbar();
        progressBar = $(".slider-progress-bar");
        progressBar.css({ width: "0%" });
        progressBar.animate({ width: "100%" }, time, "linear");
    }

    function resetProgressbar() {
        $(".slider-progress-bar").stop(true, true).css({ width: "0%" });
    }
  $('.catalog__slider').each(function() {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        prevArrow: `<button type="button" class="slick-prev first-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                    <path d="M6.5 11L1.5 6L6.5 1" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </button>`,
        nextArrow: `<button type="button" class="slick-next first-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                      <path d="M1.5 11L6.5 6L1.5 1" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>`,
        responsive: [
          {
            breakpoint: 1430,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
  });
  if ($(window).width() < 1250) {
  $('.how__list').each(function() {
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 1430,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

  });
 }
}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js